import React from 'react';
import { useDispatch } from 'react-redux';

import type { IRootDispatch } from '../../../store/models';

export function useEnterClientInIncentivesForOneAppointment(testName: string) {
  const dispatch = useDispatch<IRootDispatch>();

  return React.useCallback(async () => {
    await dispatch.showIncentives.enterOneAppointmentEnrollment(testName);
    await dispatch.showIncentives.checkIncentivesStatus();
  }, [
    dispatch.showIncentives,
    testName,
  ]);
}
